import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useServices } from "@/app/use-services";
import { useSession } from "@/lib/auth/use-session";
import { useDraft } from "@/features/onboarding/draft-store";
import { rootDestination, type ProfileState } from "@/features/onboarding/destinations";
import { useProfile } from "@/features/profile/use-profile";
import { errorMessage } from "@/lib/api/errors";
import { Button } from "@/ui/Button";
import { Screen } from "@/ui/Screen";
import { Body, Display } from "@/ui/Text";
import { Working } from "@/ui/Working";

/** The first screen: reads who this is and sends them where they belong. */
export function RootGate() {
  const { session, draft: store } = useServices();
  const snapshot = useSession(session);
  const draft = useDraft(store);
  const profile = useProfile();
  const navigate = useNavigate();

  const profileState: ProfileState = profile.isError
    ? "error"
    : profile.data === undefined
      ? "loading"
      : profile.data === null
        ? "none"
        : "present";

  const destination = rootDestination(snapshot.status, profileState, draft);

  useEffect(() => {
    if (destination) navigate(destination, { replace: true });
  }, [destination, navigate]);

  if (profile.isError) {
    return (
      <Screen centred foot={<Button label="Try again" onClick={() => void profile.refetch()} />}>
        <Display>We couldn’t load your chart.</Display>
        <Body className="mt-3 text-mid">{errorMessage(profile.error)}</Body>
      </Screen>
    );
  }
  return <Working message="One moment." />;
}
